import { Component, OnInit, computed, inject, input, signal } from '@angular/core'
import { CommonModule } from '@angular/common'
import { IAsset } from 'src/app/core/interfaces/asset.interface'
import { FormsModule } from '@angular/forms'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { ComparisonService } from 'src/app/core/services/comparison.service'
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop'
import { IconButtonModule } from '../icon-button/icon-button.module'
import { MatIconModule } from '@angular/material/icon'
import { MatButtonModule } from '@angular/material/button'


export enum ComparisonToggleLocation {
  AssetCard = 'asset-card',
  Details = 'details',
}
@Component({
  selector: 'app-comparison-toggle',
  template: `
    @switch (location()) {
      @case(ComparisonToggleLocation.AssetCard) {
        <button
          matIconButton
          class="ComparisonToggle ComparisonToggle--asset-card"
          data-testid="comparison-toggle"
          (click)="toggle($event)"
        ><mat-icon>{{icon()}}</mat-icon></button>
      }
      @case(ComparisonToggleLocation.Details) {
        <app-icon-button
          class="ComparisonToggle ComparisonToggle--details"
          icon-btn-medium
          icon-btn-icon-medium
          icon-btn-outlined
          data-testid="comparison-toggle"
          [matIcon]="icon()"
          (click)="toggle($event)"
        />
      }
    }
  `,
  styleUrls: ['./comparison-toggle.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    MatCheckboxModule,
    IconButtonModule,
    MatIconModule,
    MatButtonModule,
  ],
})
export class ComparisonToggleComponent implements OnInit {
  private _comparisonService = inject(ComparisonService)
  compareText = $localize`:@@comparison-toggle.label:Compare`

  ComparisonToggleLocation = ComparisonToggleLocation

  asset = input.required<IAsset>()
  location = input.required<ComparisonToggleLocation>()
  activeIcon = input<string>('favorite')
  inactiveIcon = input<string>('favorite_outlined')

  checked = signal(false)
  icon = computed(() => {
    return this.checked() ? this.activeIcon() : this.inactiveIcon()
  })

  isBeingCompared = computed(() => this._comparisonService.assets().some(asset => asset.equipment_number === this.asset()?.equipment_number))

  constructor() {
    toObservable(this._comparisonService.assets).pipe(
      takeUntilDestroyed(),
    ).subscribe(() => {
      this.init()
    })
    toObservable(this.asset).pipe(
      takeUntilDestroyed(),
    ).subscribe(() => {
      this.init()
    })
  }

  ngOnInit(): void {
    this.init()
  }

  init() {
    this.setToggleState()
  }

  setToggleState() {
    if (this._comparisonService.checkAssetBeingCompared(this.asset())) {
      this.checked.set(true)
    } else {
      this.checked.set(false)
    }
  }

  toggle(event: Event) {
    event.preventDefault()
    event.stopPropagation()
    const newCheckedState = !this.checked()
    this.checked.set(newCheckedState)

    if (newCheckedState) {
      this._comparisonService.addAsset(this.asset())
    } else {
      this._comparisonService.removeAsset(this.asset()?.equipment_number)
    }
  }
}
